import { render } from "./Department_Teknologji.vue?vue&type=template&id=22957b79&scoped=true"
import script from "./Department_Teknologji.vue?vue&type=script&lang=js"
export * from "./Department_Teknologji.vue?vue&type=script&lang=js"

import "./Department_Teknologji.vue?vue&type=style&index=0&id=22957b79&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22957b79"]])

export default __exports__